export default {"src":"/_next/static/media/eu-flag.203e3205.svg","height":540,"width":675,"blurWidth":0,"blurHeight":0};